import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import noimg from '../../images/no-image.webp';

gsap.registerPlugin(ScrollTrigger);

const ImageTag = ({ ImagePath, ImageAlt = 'SS Camasa, SS group India', ImageWidth, ImageHeight, ImageClass }) => {
  const imgRef = useRef(null);
  const imgSrc = ImagePath || noimg;

  useEffect(() => {
    // GSAP animation for the parallax effect
    gsap.fromTo(
      imgRef.current,
      {
        y: '0%',
      },
      {
        y: '0%', // Adjust the vertical movement for the parallax effect
        scrollTrigger: {
          trigger: imgRef.current,
          start: 'left right', // Start the animation when the image enters the viewport
          end: 'right left', // End when the image leaves the viewport
          scrub: true, // Smooth animation during scrolling
          markers: false, // Optional: Set to true to show debug markers
        },
      }
    );
  }, []);

  return (
    <img
      ref={imgRef}
      src={imgSrc}
      alt={ImageAlt}
      width={ImageWidth}
      height={ImageHeight}
      className={ImageClass}
      loading="lazy"
    />
  );
};

export default ImageTag;
